import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useEvents } from "@/events/hooks/useEvents";
import EventCard from "./event-card";
import type { Event } from "@/types/schema";

interface EventGridProps {
  limit?: number;
  className?: string;
}


export default function EventGrid({ limit = 9, className = "" }: EventGridProps) {
  // Usar o hook useEvents com filtros específicos para a home
  const { data: eventsData, isLoading, error } = useEvents({
    page: 1,
    limit,
    status: 'Approved' // Apenas eventos aprovados na home
  });

  const events = eventsData?.events || [];

  if (isLoading) {
    return (
      <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${className}`}>
        {Array.from({ length: limit }).map((_, index) => (
          <Card key={index} className="overflow-hidden border-0 shadow-md bg-white animate-pulse">
            <div className="h-32 bg-gray-200"></div>
            <CardContent className="p-5">
              <div className="h-4 bg-gray-200 rounded mb-2"></div>
              <div className="h-3 bg-gray-200 rounded mb-4"></div>
              <div className="space-y-2 mb-4">
                <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                <div className="h-3 bg-gray-200 rounded w-1/2"></div>
              </div>
              <div className="flex gap-2">
                <div className="h-8 bg-gray-200 rounded flex-1"></div>
                <div className="h-8 bg-gray-200 rounded flex-1"></div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className={`text-center py-8 ${className}`}>
        <p className="text-red-600 mb-4">{error.message || 'Erro ao carregar eventos'}</p>
        <Button onClick={() => window.location.reload()}>Tentar novamente</Button>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8">Últimos Eventos</h2>
          <div className="text-center py-8">
            <p className="text-gray-600 mb-4">Nenhum evento encontrado</p>
            <Button onClick={() => window.location.href = '/events'}>
              Ver todos os eventos
            </Button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8">Últimos Eventos</h2>

        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto ${className}`}>
          {events.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
}